@defer (when !isLoading) {
    <div style="visibility: {{(isLoading || isBrandStyleLoaded) && isBrandHeadlineFontLoaded && isBrandBodyFontLoaded ? 'visible' : 'hidden'}}">
        <router-outlet></router-outlet>
    </div>
    @if (shouldShowCookieNotice()) {
        <app-cookie-notice
            (acceptCookies)="allowCookies()"
            (openSettings)="openCookieSettings()"
            (declineCookies)="declineCookies()"
            [isDashboard]="isDashboard"
        ></app-cookie-notice>
    }
} @placeholder (minimum 0ms) {
    <div class="loading-spinner">
        <img src="/assets/other/koorvi-preloader.svg">
        <p>loading...</p>
    </div>
} @error {
    <p>error...</p>
}
